import type { ShipmentCheckCall } from "~/shared/schemas/shipment-management-schema";

import { GroupedFeedList } from "../../grouped-feed-list/grouped-feed-list.tsx";
import { TrackingHistoryItem } from "./tracking-history-item.tsx";

export const TrackingHistoryList = ({
	details,
	isSaving,
	currentUserName,
	onSelect,
}: {
	details?: Record<string, ShipmentCheckCall[]>;
	isSaving: boolean;
	currentUserName: string | null;
	onSelect: (checkCall: ShipmentCheckCall, action: string) => void;
}) => (
	<GroupedFeedList
		getItemKey={(checkCall) => `${checkCall.timestamp}-${checkCall.enteredBy}`}
		groups={details}
		isLoading={isSaving}
		renderItem={(checkCall) => (
			<TrackingHistoryItem
				canModify={
					currentUserName != null && checkCall.enteredBy === currentUserName
				}
				checkCall={checkCall}
				isSaving={isSaving}
				onSelect={onSelect}
			/>
		)}
	/>
);
